import { ICardspartnersItem, IpaginatedCardspartners } from '../models'

export enum CardspartnersActionTypes {
  SEARCH_CARDSPARTNERS = 'cardspartners/search',
  SEARCHING_CARDSPARTNERS = 'cardspartners/searching',
  FOUND_CARDSPARTNERS = 'cardspartners/found',
  SEARCHING_CARDSPARTNERS_FAILED = 'cardspartners/searching_failed',

  LOAD_CARDSPARTNERS = 'cardspartners/load',
  LOADING_CARDSPARTNERS = 'cardspartners/loading',
  LOADED_CARDSPARTNERS = 'cardspartners/loaded',
  LOADING_CARDSPARTNERS_FAILED = 'cardspartners/loading_failed',

  ADD_CARDSPARTNERS = 'cardspartners/add',
  ADDING_CARDSPARTNERS = 'cardspartners/adding',
  ADDED_CARDSPARTNERS = 'cardspartners/added',
  ADDING_CARDSPARTNERS_FAILED = 'cardspartners/adding_failed',

  REMOVE_CARDPARTNERS = 'cardspartners/remove',
  REMOVING_CARDPARTNERS = 'cardspartners/removing',
  REMOVED_CARDPARTNERS = 'cardspartners/removed',
  REMOVING_CARDPARTNERS_FAILED = 'cardspartners/removing_failed',

  SOFT_REMOVE_CARDSPARTNERS = 'cardspartners/soft_remove',
  SOFT_REMOVING_CARDSPARTNERS = 'cardspartners/soft_removing',
  SOFT_REMOVED_CARDSPARTNERS = 'cardspartners/soft_removed',
  SOFT_REMOVING_CARDSPARTNERS_FAILED = 'cardspartners/soft_removing_failed',

  EDIT_CARDSPARTNERS = 'cardspartners/edit',
  EDITING_CARDSPARTNERS = 'cardspartners/editing',
  EDITED_CARDSPARTNERS = 'cardspartners/edited',
  EDITING_CARDSPARTNERS_FAILED = 'cardspartners/editing_failed',

  VIEW_CARDSPARTNERS = 'cardspartners/view',
  VIEWING_CARDSPARTNERS = 'cardspartners/viewing',
  VIEWED_CARDSPARTNERS = 'cardspartners/viewed',
  VIEWING_CARDSPARTNERS_FAILED = 'cardspartners/viewing_failed',
}

export function searchCardspartners(searchOptions: TSearchOptions | string, keep?: boolean): ISearchCardspartnersAction {
  return {
    type: CardspartnersActionTypes.SEARCH_CARDSPARTNERS,
    searchOptions: typeof searchOptions === 'string' ? { searchString: searchOptions } : searchOptions,
    keep: keep,
  }
}

export function searchingCardspartners(): ISearchingCardspartnersAction {
  return {
    type: CardspartnersActionTypes.SEARCHING_CARDSPARTNERS,
  }
}

export function foundCardspartners(cardspartners: IpaginatedCardspartners, keep?: boolean): IFoundCardspartnersAction {
  return {
    type: CardspartnersActionTypes.FOUND_CARDSPARTNERS,
    keep: keep,
    payload: {
      cardspartners,
    },
  }
}

export function searchingCardspartnersFailed(): ISearchingCardspartnersFailedAction {
  return {
    type: CardspartnersActionTypes.SEARCHING_CARDSPARTNERS_FAILED,
  }
}

export function loadCardspartners(loadOptions: TSearchOptions): ILoadCardspartnersAction {
  return {
    type: CardspartnersActionTypes.LOAD_CARDSPARTNERS,
    loadOptions: loadOptions,
  }
}

export function loadingCardspartners(): ILoadingCardspartnersAction {
  return {
    type: CardspartnersActionTypes.LOADING_CARDSPARTNERS,
  }
}

export function loadedCardspartners(cardspartners: IpaginatedCardspartners): ILoadedCardspartnersAction {
  return {
    type: CardspartnersActionTypes.LOADED_CARDSPARTNERS,
    payload: {
      cardspartners,
    },
  }
}

export function loadingCardspartnersFailed(): ILoadingCardspartnersFailedAction {
  return {
    type: CardspartnersActionTypes.LOADING_CARDSPARTNERS_FAILED,
  }
}

export function addCardspartners(cardpartners: ICardspartnersItem): IAddCardspartnersAction {
  return {
    type: CardspartnersActionTypes.ADD_CARDSPARTNERS,
    payload: cardpartners,
  }
}

export function addingCardspartners(): IAddingCardspartnersAction {
  return {
    type: CardspartnersActionTypes.ADDING_CARDSPARTNERS,
  }
}

export function addedCardspartners(cardspartners: IpaginatedCardspartners): IAddedCardspartnersAction {
  return {
    type: CardspartnersActionTypes.ADDED_CARDSPARTNERS,
    payload: {
      cardspartners,
    },
  }
}

export function addingCardspartnersFailed(errData: { data: { message: string; field?: string }; status: number }): IAddingCardspartnersFailedAction {
  return {
    type: CardspartnersActionTypes.ADDING_CARDSPARTNERS_FAILED,
    message: errData.data.message,
    status: errData.status,
    field: errData.data.field,
  }
}

export function removeCardpartners(cardpartners: ICardspartnersItem): IRemoveCardpartnersAction {
  return {
    type: CardspartnersActionTypes.REMOVE_CARDPARTNERS,
    payload: cardpartners,
  }
}

export function removingCardpartners(): IRemovingCardpartnersAction {
  return {
    type: CardspartnersActionTypes.REMOVING_CARDPARTNERS,
  }
}

export function removedCardpartners(): IRemovedCardpartnersAction {
  return {
    type: CardspartnersActionTypes.REMOVED_CARDPARTNERS,
  }
}

export function removingCardpartnersFailed(): IRemovingCardpartnersFailedAction {
  return {
    type: CardspartnersActionTypes.REMOVING_CARDPARTNERS_FAILED,
  }
}

export function softRemoveCardspartners(cardpartners: ICardspartnersItem): ISoftRemoveCardspartnersAction {
  return {
    type: CardspartnersActionTypes.SOFT_REMOVE_CARDSPARTNERS,
    payload: cardpartners,
  }
}

export function softRemovingCardspartners(): ISoftRemovingCardspartnersAction {
  return {
    type: CardspartnersActionTypes.SOFT_REMOVING_CARDSPARTNERS,
  }
}

export function softRemovedCardspartners(cardpartners: ICardspartnersItem): ISoftRemovedCardspartnersAction {
  return {
    type: CardspartnersActionTypes.SOFT_REMOVED_CARDSPARTNERS,
    payload: cardpartners,
  }
}

export function softRemovingCardspartnersFailed(errData: {
  data: { message: string; field?: string }
  status: number
}): ISoftRemovingCardspartnersFailedAction {
  return {
    type: CardspartnersActionTypes.SOFT_REMOVING_CARDSPARTNERS_FAILED,
    message: errData.data.message,
    status: errData.status,
    field: errData.data.field,
  }
}

export function editCardspartners(cardpartners: ICardspartnersItem): IEditCardspartnersAction {
  return {
    type: CardspartnersActionTypes.EDIT_CARDSPARTNERS,
    payload: cardpartners,
  }
}

export function editingCardspartners(): IEditingCardspartnersAction {
  return {
    type: CardspartnersActionTypes.EDITING_CARDSPARTNERS,
  }
}

export function editedCardspartners(cardspartners: ICardspartnersItem): IEditedCardspartnersAction {
  return {
    type: CardspartnersActionTypes.EDITED_CARDSPARTNERS,
    payload: cardspartners,
  }
}

export function editingCardspartnersFailed(errData: {
  data: { message: string; field?: string }
  status: number
}): IEditingCardspartnersFailedAction {
  return {
    type: CardspartnersActionTypes.EDITING_CARDSPARTNERS_FAILED,
    message: errData.data.message,
    status: errData.status,
    field: errData.data.field,
  }
}

export function viewCardspartners(cardpartners: ICardspartnersItem): IViewCardspartnersAction {
  return {
    type: CardspartnersActionTypes.VIEW_CARDSPARTNERS,
    payload: cardpartners,
  }
}

export function viewingCardspartners(): IViewingCardspartnersAction {
  return {
    type: CardspartnersActionTypes.VIEWING_CARDSPARTNERS,
  }
}

export function viewedCardspartners(cardspartners: ICardspartnersItem): IViewedCardspartnersAction {
  return {
    type: CardspartnersActionTypes.VIEWED_CARDSPARTNERS,
    payload: cardspartners,
  }
}

export function viewingCardspartnersFailed(): IViewingCardspartnersFailedAction {
  return {
    type: CardspartnersActionTypes.VIEWING_CARDSPARTNERS_FAILED,
  }
}

type TSearchOptions = {
  searchString?: string
  searchField?: string
  page?: number
  limit?: number
  populate?: boolean
  sort?: {
    field: string
    method?: 'asc' | 'desc'
  }
  filters?: { field: string; value: string }[]
}

export interface ISearchCardspartnersAction {
  type: CardspartnersActionTypes.SEARCH_CARDSPARTNERS
  searchOptions: TSearchOptions
  keep?: boolean
}

export interface ISearchingCardspartnersAction {
  type: CardspartnersActionTypes.SEARCHING_CARDSPARTNERS
}

export interface IFoundCardspartnersAction {
  type: CardspartnersActionTypes.FOUND_CARDSPARTNERS
  keep?: boolean
  payload: {
    cardspartners: IpaginatedCardspartners
  }
}

export interface ISearchingCardspartnersFailedAction {
  type: CardspartnersActionTypes.SEARCHING_CARDSPARTNERS_FAILED
}

export interface ILoadCardspartnersAction {
  type: CardspartnersActionTypes.LOAD_CARDSPARTNERS
  loadOptions: TSearchOptions
}

export interface ILoadingCardspartnersAction {
  type: CardspartnersActionTypes.LOADING_CARDSPARTNERS
}

export interface ILoadedCardspartnersAction {
  type: CardspartnersActionTypes.LOADED_CARDSPARTNERS
  payload: {
    cardspartners: IpaginatedCardspartners
  }
}

export interface ILoadingCardspartnersFailedAction {
  type: CardspartnersActionTypes.LOADING_CARDSPARTNERS_FAILED
}

export interface IAddCardspartnersAction {
  type: CardspartnersActionTypes.ADD_CARDSPARTNERS
  payload: ICardspartnersItem
}

export interface IAddingCardspartnersAction {
  type: CardspartnersActionTypes.ADDING_CARDSPARTNERS
}

export interface IAddedCardspartnersAction {
  type: CardspartnersActionTypes.ADDED_CARDSPARTNERS
  payload: {
    cardspartners: IpaginatedCardspartners
  }
}

export interface IAddingCardspartnersFailedAction {
  type: CardspartnersActionTypes.ADDING_CARDSPARTNERS_FAILED
  message: string
  status: number
  field?: string
}

export interface IRemoveCardpartnersAction {
  type: CardspartnersActionTypes.REMOVE_CARDPARTNERS
  payload: ICardspartnersItem
}

export interface IRemovingCardpartnersAction {
  type: CardspartnersActionTypes.REMOVING_CARDPARTNERS
}

export interface IRemovedCardpartnersAction {
  type: CardspartnersActionTypes.REMOVED_CARDPARTNERS
}

export interface IRemovingCardpartnersFailedAction {
  type: CardspartnersActionTypes.REMOVING_CARDPARTNERS_FAILED
}

export interface ISoftRemoveCardspartnersAction {
  type: CardspartnersActionTypes.SOFT_REMOVE_CARDSPARTNERS
  payload: ICardspartnersItem
}

export interface ISoftRemovingCardspartnersAction {
  type: CardspartnersActionTypes.SOFT_REMOVING_CARDSPARTNERS
}

export interface ISoftRemovedCardspartnersAction {
  type: CardspartnersActionTypes.SOFT_REMOVED_CARDSPARTNERS
  payload: ICardspartnersItem
}

export interface ISoftRemovingCardspartnersFailedAction {
  type: CardspartnersActionTypes.SOFT_REMOVING_CARDSPARTNERS_FAILED
  message: string
  status: number
  field?: string
}

export interface IEditCardspartnersAction {
  type: CardspartnersActionTypes.EDIT_CARDSPARTNERS
  payload: ICardspartnersItem
}

export interface IEditingCardspartnersAction {
  type: CardspartnersActionTypes.EDITING_CARDSPARTNERS
}

export interface IEditedCardspartnersAction {
  type: CardspartnersActionTypes.EDITED_CARDSPARTNERS
  payload: ICardspartnersItem
}

export interface IEditingCardspartnersFailedAction {
  type: CardspartnersActionTypes.EDITING_CARDSPARTNERS_FAILED
  message: string
  status: number
  field?: string
}

export interface IViewCardspartnersAction {
  type: CardspartnersActionTypes.VIEW_CARDSPARTNERS
  payload: ICardspartnersItem
}

export interface IViewingCardspartnersAction {
  type: CardspartnersActionTypes.VIEWING_CARDSPARTNERS
}

export interface IViewedCardspartnersAction {
  type: CardspartnersActionTypes.VIEWED_CARDSPARTNERS
  payload: ICardspartnersItem
}

export interface IViewingCardspartnersFailedAction {
  type: CardspartnersActionTypes.VIEWING_CARDSPARTNERS_FAILED
}

export type CardspartnersAction =
  | ISearchCardspartnersAction
  | ISearchingCardspartnersAction
  | IFoundCardspartnersAction
  | ISearchingCardspartnersFailedAction
  | ILoadCardspartnersAction
  | ILoadingCardspartnersAction
  | ILoadedCardspartnersAction
  | ILoadingCardspartnersFailedAction
  | IAddCardspartnersAction
  | IAddingCardspartnersAction
  | IAddedCardspartnersAction
  | IAddingCardspartnersFailedAction
  | IRemoveCardpartnersAction
  | IRemovingCardpartnersAction
  | IRemovedCardpartnersAction
  | IRemovingCardpartnersFailedAction
  | ISoftRemoveCardspartnersAction
  | ISoftRemovingCardspartnersAction
  | ISoftRemovedCardspartnersAction
  | ISoftRemovingCardspartnersFailedAction
  | IEditCardspartnersAction
  | IEditingCardspartnersAction
  | IEditedCardspartnersAction
  | IEditingCardspartnersFailedAction
  | IViewCardspartnersAction
  | IViewingCardspartnersAction
  | IViewedCardspartnersAction
  | IViewingCardspartnersFailedAction
